module.exports = __webpack_public_path__ + "static/media/spr_declaration_de_sante.9c3cc810.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/spr/documents/adhesion/spr_declaration_de_sante.pdf
// module id = 858
// module chunks = 40